var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"access"}},[(_vm.showSpinner)?_c('Spinner'):_vm._e(),_c('Header'),_vm._m(0),_c('div',{staticClass:"access-content"},[((_vm.dataFetched || _vm.toolsDataFetched) && this.$store.state.cachedRepositories[0].collaborators)?_c('AccessTable'):_vm._e()],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-header"},[_c('h2',[_vm._v("Access")])])
}]

export { render, staticRenderFns }